const COMMON_CONST_REG = /^[A-Z_]{2,}$/
const COMMON_CONST_WITH_NUMBER_REG = /^[A-Z_1-9]{2,}$/
const COMMON_WRAPPER_REG = /^(_*)(.*?)(_*)$/ // __(xxxxxx)__


function isConst(key) {
  return COMMON_CONST_REG.test(key)
}

function isConstWithNumber(key) {
  return COMMON_CONST_WITH_NUMBER_REG.test(key)
}

function commonConvert(key, converter) {
  if (isConstWithNumber(key)) { // if it is const, return directly
    return key
  }

  return key.replace(COMMON_WRAPPER_REG, (m, start, content, end) => {
    const convertedContent = converter(content)

    return `${start}${convertedContent}${end}`
  })
}

function underscoreCase(key, options = {}) {
  const separateNumber = options.separateNumber || false

  const underscoreKey = commonConvert(key, content => {
    const spliter = separateNumber ? /[A-Z]|[\d]+|h5/g : /[A-Z]|h5/g
    const phases = []
    const contentLen = content.length


    let lastIndex = 0
    let matched = spliter.exec(content)

    if (!matched) {
    // if no matched, it is mean the original text not contains spliter, so just push it
      phases.push(content)
    }

    while (matched) {
      const currentIndex = matched.index
      const word = content.substring(lastIndex, matched.index)

      phases.push(word)

      lastIndex = currentIndex
      matched = spliter.exec(content)

      if (!matched) { // if no next matched, then push as last word
        const lastWord = content.substring(currentIndex, contentLen)

        phases.push(lastWord)
      }
    }

    const result = phases.filter(val => val).map((val, i) => {
      if (i === 0 || isConst(val)) {
        return val
      }

      return val.replace(/^[A-Z]/, mat => mat.toLowerCase())
    })

    return result.join('_')
  })

  return underscoreKey
}

function camelCase(key) {
  const camelKey = commonConvert(key, content => {
    const spliter = '_'
    const phases = content.split(spliter)

    const result = phases.filter(val => val).map((val, i) => {
      if (i === 0 || isConst(val)) {
        return val
      }

      return val.replace(/^[a-z]/, mat => mat.toUpperCase())
    })

    return result.join('')
  })

  return camelKey
}

export {
  underscoreCase,
  camelCase
}
